import base from '../base/base';
import header from '../base/header';
import threeThings from '../../components/threethings/threethings';
import SocialBarLoader from '../../components/SocialBar/SocialBarLoader';


new SocialBarLoader();



// WEBPACK FOOTER //
// ./assets/layouts/gallery/gallery.js